// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
import MenuController from "./menu_controller"
import DarkModeController from "./dark_mode_controller"
import ExamQuestionPreviewController from "./exam_question_preview_controller"
import ExamAdmissionPollingController from "./exam_admission_polling_controller"
import RspoDirectoryController from "./rspo_directory_controller"
import ProtocolController from "./protocol_controller"
import TurnstileController from "./turnstile_controller"
import TwoFactorCredentialController from "./two_factor_credential_controller"
import RecoveryCodeCopyController from "./recovery_code_copy_controller"

application.register("hello", HelloController)
application.register("menu", MenuController)
application.register("dark-mode", DarkModeController)
application.register("exam-question-preview", ExamQuestionPreviewController)
application.register("exam-admission-polling", ExamAdmissionPollingController)
application.register("rspo-directory", RspoDirectoryController)
application.register("protocol", ProtocolController)
application.register("turnstile", TurnstileController)
application.register("two-factor-credential", TwoFactorCredentialController)
application.register("recovery-code-copy", RecoveryCodeCopyController)

import HandbookEditorController from "./handbook_editor_controller"
import HandbookPrivateController from "./handbook_private_controller"
application.register("handbook-editor", HandbookEditorController)
application.register("handbook-private", HandbookPrivateController)
